import Vue from 'vue';
import VuePlayer from '@iomariani/vue-player';
import '@iomariani/vue-player/dist/vue-player.css';

Vue.component('vue-player', VuePlayer);
